<!--
  - MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Website: https://www.4myth.com
  -->

<template>
  <v-app id="main-app">
    <template v-if="AppReady">
      <!--<app-system-bar class="d-print-none" />-->
      <app-bar
        :hide-drawer-icon="!AppIsSmall"
        :navigation.sync="navigation"
      />
      <app-snackbar
        v-if="AppSnackbar"
        class="d-print-none"
      />
      <app-navigation
        v-model="navigation"
      />
      <v-main
        id="main-content"
        class="main-container"
      >
        <app-progress-linear
          v-if="!AppIsSmall"
          class="d-print-none"
        />
        <!--<v-container class="">
          <v-row justify="start">
            <v-col cols="1">
              <v-img
                class="pointer"
                :src="AppLogo"
                width="100"
                max-height="100%"
                @click="!isRoute(APP_ROUTES.homePage) ? navigate(APP_ROUTES.homePage) : undefined"
              />
            </v-col>
            <v-col
              cols="4"
              class="text-start text-sm-caption d-print-none font-weight-regular"
            >
              <v-btn
                v-for="e in bottomNavigationButtons"
                :key="e.value"
                :to="e.to"
                color="gray"
                depressed
                exact-path
                height="60"
                link
                plain
              >
                <span>{{ parseAttribute(e.text) }}</span>
                &lt;!&ndash;<v-badge&ndash;&gt;
                &lt;!&ndash;  v-if="UnreadAppNotifications>0 && e.badge"&ndash;&gt;
                &lt;!&ndash;  content="*"&ndash;&gt;
                &lt;!&ndash;  :acontent="UnreadAppNotifications"&ndash;&gt;
                &lt;!&ndash;  color="transparent"&ndash;&gt;
                &lt;!&ndash;  class="error&#45;&#45;text"&ndash;&gt;
                &lt;!&ndash;  overlap&ndash;&gt;
                &lt;!&ndash;&gt;&ndash;&gt;
                &lt;!&ndash;  <v-icon>&ndash;&gt;
                &lt;!&ndash;    {{ e.icon }}&ndash;&gt;
                &lt;!&ndash;  </v-icon>&ndash;&gt;
                &lt;!&ndash;</v-badge>&ndash;&gt;
                <v-icon :color="UnreadAppNotifications>0 && e.badge ? 'error' : undefined">
                  {{ e.icon }}
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>-->

        <slide-fade-transition>
          <layout-router-view v-if="AppReady" />
        </slide-fade-transition>
        <layout-router-view
          v-if="AppReady"
          name="helper"
        />
        <slide-fade-transition>
          <slot v-if="AppReady" />
        </slide-fade-transition>
      </v-main>
      <v-bottom-navigation
        v-if="AppReady && AppIsSmall && authUser"
        app
        background-color="gray"
        class="d-none rounded-t"
        grow
        height="60"
        mandatory
      >
        <v-btn
          v-for="e in bottomNavigationButtons"
          :key="e.value"
          :to="e.to"
          color="gray"
          depressed
          exact-path
          height="60"
          link
          plain
        >
          <span>{{ parseAttribute(e.text) }}</span>
          <!--<v-badge-->
          <!--  v-if="UnreadAppNotifications>0 && e.badge"-->
          <!--  content="*"-->
          <!--  :acontent="UnreadAppNotifications"-->
          <!--  color="transparent"-->
          <!--  class="error&#45;&#45;text"-->
          <!--  overlap-->
          <!--&gt;-->
          <!--  <v-icon>-->
          <!--    {{ e.icon }}-->
          <!--  </v-icon>-->
          <!--</v-badge>-->
          <v-icon :color="UnreadAppNotifications>0 && e.badge ? 'error' : undefined">
            {{ e.icon }}
          </v-icon>
        </v-btn>
      </v-bottom-navigation>
      <app-main-footer
        v-if="AppReady"
        class="d-print-none"
      />
    </template>
  </v-app>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import LayoutRouterView from '@/layouts/LayoutRouterView'
import { MetaInfoMixin } from '@mixins'
import SlideFadeTransition from '@components/SlideFadeTransition'

export default {
  name: 'LandingLayout',
  components: { SlideFadeTransition, LayoutRouterView },
  mixins: [MetaInfoMixin],
  data () {
    return {
      // navigation: this.$vuetify.breakpoint.mdAndUp,
      // navigation: this.$vuetify.breakpoint.lgAndUp,
      navigation: !1,
      bottomNavigation: null
    }
  },
  computed: {
    bottomNavigationButtons () {
      return []
    },
    AppSnackbar: {
      set (value) {
        mapMutations('snackbar', ['setShow']).setShow.call(this, value)
      },
      get () {
        return mapGetters('snackbar', ['getShow']).getShow.call(this)
      }
    }
  },
  watch: {
    // $route: {
    //   deep: !0,
    //   immediate: !0,
    //   handler: 'checkAuthDialog'
    // },
  },
  mounted () {
  },
  methods: {}
}
</script>

<style>
@media print {
  .main-container {
    background: none !important;
  }

  .v-main {
    /*padding-top: 0 !important;*/
    padding: 0 !important;
  }
}

.bg-landing {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
  url('/img/landing/slider.png') left top fixed no-repeat;
  background-size: cover;
}

.bg-vision {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
  url('/img/landing/vision.png') left top fixed no-repeat;
  background-size: cover;
}

.main-home-container {
  .container {
    > .row {
      max-width: 1170px;
      margin-left: auto;
      margin-right: auto;
    }
  }
}

.app-bar {
  .v-toolbar__content {
    max-width: 1170px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
